module.exports = __webpack_public_path__ + "assets/img/17_1415_big.65cb7356.jpg";